module.exports = __webpack_public_path__ + "media/images/vp/slider.index.03-fb764e0d1856095a0f91332b7fb562d9.jpg";